var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopDots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6842 31.2202V33.6969H14.3271V31.2202H25.6842ZM35.7994 6.30313L35.8 26.7292C35.8 26.7658 35.7914 26.8012 35.7887 26.8378V28.3726H33.3126V28.3678H6.67605V28.3726H4.19995V25.896H4.2107V6.30313H35.7994ZM33.3126 8.78031H6.68734V25.896H33.3126V8.78031ZM13.8081 15.5083V19.168H11.332V15.5083H13.8081ZM18.7614 15.5083V19.168H16.2853V15.5083H18.7614ZM23.7147 15.5083V19.168H21.2386V15.5083H23.7147ZM28.6674 15.5083V19.168H26.1913V15.5083H28.6674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopDots);
export default __webpack_public_path__ + "static/media/DesktopDots.43d32419ccd5cf18cf42036ff5319184.svg";
export { ForwardRef as ReactComponent };